module.exports = __webpack_public_path__ + "img/img-25.ff99fb79.jpg";